export const ASC_SORT_TYPE_API_REF = 'ASC';
export const DESC_SORT_TYPE_API_REF = 'DESC';
